import React, { useState } from 'react';
import Button from 'components/base/Button';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface CommentFormProps {
    parentId: number;
    parentType: 'question' | 'answer';
    onSubmit: (comment: { content: string; parentId: number; parentType: string }) => void;
}

const CommentForm = ({ parentId, parentType, onSubmit }: CommentFormProps) => {


    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!content.trim()) return;

        setIsSubmitting(true);
        try {
            await onSubmit({
                content: content.trim(),
                parentId,
                parentType
            });
            setContent('');
            setIsExpanded(false);
        } catch (error) {
            console.error('Failed to submit comment:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="mt-4">
            {!isExpanded ? (

                <button className="btn btn-link btn-sm p-0" onClick={() => setIsExpanded(true)} >
                    {t("CommentForm.add_a_comment")}
                </button>


            ) : (
                <form onSubmit={handleSubmit}>
                    <div className="flex items-start">
                        <Form.Control as="textarea" rows={3}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            placeholder={t("CommentForm.add_a_comment_placeholder")}
                            className="w-100" style={{ minHeight: "100px" }}
                            disabled={isSubmitting}
                        />
                    </div>
                    <div className="flex justify-end mt-2">
                        <Button
                            className='me-4'
                            type="button"
                            variant="primary"
                            onClick={() => {
                                setIsExpanded(false);
                                setContent('');
                            }}
                            disabled={isSubmitting}
                        >
                            {t("cancel")}
                        </Button>
                        <Button
                            type="submit"
                            disabled={!content.trim() || isSubmitting}
                        >
                            {isSubmitting ? t("CommentForm.posting_in_progress") : t("CommentForm.post_a_comment_placeholder")}
                        </Button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default CommentForm;